<div *ngIf="hasData && loaded" class="row">
  <div class="col-md-9 mb-3">
    <div class="highchart-chart" id="{{'chartFunnel' + id}}"></div>
  </div>
  <div class="col-md-3 mb-3">
    <div class="statistics_chart_title">Seguimiento de reimpactos</div>
    <div class="highchart-chart" id="{{'chartDonut' + id}}"></div>
    <div *ngIf="model">
      <div class="reimpacted_tracking_data">
        <div>
          <div class="data-dot lightteal"></div>
        </div>
        <div class="data-title">Reimpacto
          <!-- con llamada -->:
        </div>
        <div class="data-value"><strong>{{model.Call | number}}</strong></div>
      </div>
      <!-- <div class="reimpacted_tracking_data">
                <div>
                    <div class="data-dot teal"></div>
                </div>
                <div class="data-title">Reimpacto con email:</div>
                <div class="data-value"><strong>{{model.Email | number}}</strong></div>
            </div> -->
      <div class="reimpacted_tracking_data">
        <div>
          <div class="data-dot red"></div>
        </div>
        <div class="data-title">Pendientes:</div>
        <div class="data-value"><strong>{{model.Pending | number}}</strong></div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!hasData && loaded" class="row">
  <div class="col-md-9 pb-7">
    No hay datos
  </div>
</div>